import { Image, useModalState } from "@clipboard-health/ui-components";
import { Box } from "@mui/material";
import { FullScreenDialog } from "@src/appV2/lib/Dialogs";
import { IconButton } from "@src/appV2/redesign/components/IconButton";

export function TimeclockInstructionImage(props: { imageUrl: string }) {
  const { imageUrl } = props;
  const modalState = useModalState();

  return (
    <>
      <Box
        sx={{
          height: "35vh",
          width: "100%",
          position: "relative",
          borderRadius: 2,
          background: `url(${imageUrl}), black`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
        onClick={modalState.openModal}
      >
        <Box sx={{ position: "absolute", top: 10, right: 10 }}>
          <IconButton
            iconType="chevron-up"
            size="small"
            variant="outlined"
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 1)",
              },
            }}
            onClick={modalState.openModal}
          />
        </Box>
      </Box>
      <FullScreenDialog modalState={modalState} variant="primary">
        <Box
          sx={{
            height: "100%",
            width: "100%",
            position: "relative",
            alignContent: "center",
            background: (theme) => theme.palette.common.black,
          }}
        >
          <Box sx={{ position: "absolute", top: 0, right: 0, padding: 3 }}>
            <IconButton
              iconType="close"
              size="large"
              variant="outlined"
              sx={{
                backgroundColor: (theme) => theme.palette.action.hover,
                color: (theme) => theme.palette.common.white,
                borderColor: (theme) => theme.palette.action.disabled,
                "&:hover": {
                  backgroundColor: (theme) => theme.palette.action.selected,
                },
              }}
              onClick={modalState.closeModal}
            />
          </Box>
          <Image
            src={imageUrl}
            alt="Timeclock compliance instructions"
            sx={{
              width: "100%",
              maxHeight: "100%",
              display: "block",
              objectFit: "contain",
            }}
          />
        </Box>
      </FullScreenDialog>
    </>
  );
}
